import * as React from 'react'

const MEDIUM_BREAKPOINT = 768
const LARGE_BREAKPOINT = 1024
const XLARGE_BREAKPOINT = 1280

export function useScreenBreakpoints() {
  const [isMediumScreen, setIsMediumScreen] = React.useState<boolean | undefined>(undefined)
  const [isLargeScreen, setIsLargeScreen] = React.useState<boolean | undefined>(undefined)
  const [isXLargeScreen, setIsXLargeScreen] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mqMedium = window.matchMedia(`(min-width: ${MEDIUM_BREAKPOINT}px)`)
    const mqLarge = window.matchMedia(`(min-width: ${LARGE_BREAKPOINT}px)`)
    const mqXLarge = window.matchMedia(`(min-width: ${XLARGE_BREAKPOINT}px)`)

    const onChange = () => {
      setIsMediumScreen(window.innerWidth >= MEDIUM_BREAKPOINT)
      setIsLargeScreen(window.innerWidth >= LARGE_BREAKPOINT)
      setIsXLargeScreen(window.innerWidth >= XLARGE_BREAKPOINT)
    }
    mqMedium.addEventListener('change', onChange)
    mqLarge.addEventListener('change', onChange)
    mqXLarge.addEventListener('change', onChange)

    setIsMediumScreen(window.innerWidth >= MEDIUM_BREAKPOINT)
    setIsLargeScreen(window.innerWidth >= LARGE_BREAKPOINT)
    setIsXLargeScreen(window.innerWidth >= XLARGE_BREAKPOINT)

    return () => {
      mqMedium.removeEventListener('change', onChange)
      mqLarge.removeEventListener('change', onChange)
      mqXLarge.removeEventListener('change', onChange)
    }
  }, [])

  return {
    isMediumScreen: Boolean(isMediumScreen),
    isMobile: !isMediumScreen,
    isLargeScreen: Boolean(isLargeScreen),
    isXLargeScreen: Boolean(isXLargeScreen),
  }
}
